// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  scroll-snap-align: start;
  flex-shrink: 0;
  box-sizing: border-box;
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) =>
      props.isLastImage
        ? `
        margin-right: 11px;
      }
    `
        : ``}
  }
  .stylitics-top-promo-item {
    flex-direction: column;
  }
`;

export const CardImage = styled.img`
  display: block;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    width: 150px;
    height: 185px;
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    width: 250px;
    height: 285px;
  }
  @media ${(props) => props.theme.mediaQuery.largeOnly} {
    width: 300px;
    height: 412px;
  }
  @media ${(props) => props.theme.mediaQuery.xLargeOnly} {
    width: 352px;
    height: 414px;
  }
  @media ${(props) => props.theme.mediaQuery.desktopOnly} {
    width: 372px;
    height: 430px;
  }
  @media ${(props) => props.theme.mediaQuery.bigScreen} {
    width: 373px;
    height: 430px;
  }
`;

export const CtaText = styled.span`
  padding: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS} 0;
  font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
  font-size: ${(props) => props.theme.typography.fontSizes.fs12};
  font-family: ${(props) => props.theme.typography.fonts.secondary};

  @media ${(props) => props.theme.mediaQuery.medium} {
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
  }
`;